import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import type { SimpleChanges } from '@angular/core';
import { ICustomAttribute } from '../../models/customAttribute.model';
import { CustomAttributeService } from './custom-attribute.service';

@Component({
  selector: 'app-custom-attribute',
  templateUrl: './custom-attribute.component.html',
  styleUrl: './custom-attribute.component.scss'
,  standalone: false
})
export class CustomAttributeComponent implements OnInit {

  @Input() categoryType: string;
  @Input() categoryValue: string;
  showAttributeInputs :boolean = false; 
  attributeName : string;
  attributeValue : string;
  attributes : ICustomAttribute[]=[];
  @Output() onChangeOfAttribute: EventEmitter<ICustomAttribute[]> = new EventEmitter<ICustomAttribute[]>(); 

  constructor(private custAttrService : CustomAttributeService) {}

   ngOnChanges(changes: SimpleChanges) {
    //debugger;
    if (changes['categoryValue']) {
      console.log('categoryValue changed:', changes['categoryValue'].currentValue);
      // Perform any additional logic here
      this.getCustomAttributes();
    }
  }

  ngOnInit() {
    if(this.categoryType != null && this.categoryValue != null){
      this.getCustomAttributes();
    }
  }

  getCustomAttributes() { 
    this.custAttrService.getAttributeByCategory(this.categoryType, this.categoryValue).subscribe((response: ICustomAttribute[]) => {
      this.attributes = response;
      console.log("this.attributes:",this.attributes);
    });
  }
  addAttrBtnClick(){
    this.showAttributeInputs = true;
    this.attributeName = '';
    this.attributeValue = '';
  }

  addAttribute(attrId :number){
    this.attributes.push({
      customAttributeRelId : attrId,    
      attributeName: this.attributeName, 
      attributeValue: this.attributeValue,
      categoryType: this.categoryType,
      categoryValue: this.categoryValue,
      isActive: true
    });
    this.showAttributeInputs = false;
    this.onChangeOfAttribute.emit(this.attributes);
    console.log(this.attributes);
  }

  cancel(){
    this.showAttributeInputs = false;
  }

  deleteAttribute(index :number){
     this.attributes[index].isActive = false;    
    this.onChangeOfAttribute.emit(this.attributes);
  }

  onValueChange(){  
    this.onChangeOfAttribute.emit(this.attributes);
  }

}
